import { Label } from "@radix-ui/react-label";
import { cn } from "@/lib/utils";
import { ComponentProps, useId } from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { FilterColumn } from "..";

interface BooleanFilterFieldProps<T> extends Omit<
    ComponentProps<typeof Select>,
    "onChange" | "value"
> {
    column: FilterColumn<T>;
    value: string | null;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

export default function BooleanFilterField<T>({
    column,
    value,
    onChange,
    placeholder = "Select option...",
    className,
    ...rest
}: BooleanFilterFieldProps<T>) {
    const id = useId();

    return (
        <div className={cn("flex flex-col gap-2")}>
            <Label htmlFor={id} className={cn("text-sm font-medium")}>
                {column.headingText}
            </Label>
            <Select value={value || ""} onValueChange={onChange} {...rest}>
                <SelectTrigger id={id}>
                    <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="true">
                        {column.id === "is_mobilized"
                            ? "Mobilized"
                            : "Paid/Received"}
                    </SelectItem>
                    <SelectItem value="false">
                        {column.id === "is_mobilized"
                            ? "Demobilized"
                            : "Yet To Receive/Pay"}
                    </SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
}
